import * as Link from "next/link"
import {Typography} from "@mui/material";
import MenuIcon from "components/MenuIcon"


export default function SubMenuItem({title, subTitle, to, icon}) {
    return <div className="d-flex flex-row">
        <MenuIcon iconName={icon} color="#D8C149" size="18" className="m-2" />
        <div className="ml-10 d-flex flex-column align-items-start">
            <Link href={to} style={{paddingBottom: 1}}>
                <p className="text-dark">{title}</p>
            </Link>
            <Typography variant={'caption'}>{subTitle}</Typography>
        </div>
    </div>
}

